import type { BotProtectionProviderAdapter, BotProtectionProviderId } from './types'
import { turnstileBotProtectionAdapter } from './turnstileAdapter'

const DEFAULT_ADAPTERS = [turnstileBotProtectionAdapter] as const

const ADAPTERS_BY_PROVIDER = new Map<BotProtectionProviderId, BotProtectionProviderAdapter>(
  DEFAULT_ADAPTERS.map((adapter) => [adapter.providerId, adapter]),
)

export const resolveBotProtectionAdapter = (
  providerId: BotProtectionProviderId,
): BotProtectionProviderAdapter | null => ADAPTERS_BY_PROVIDER.get(providerId) ?? null

export const listBotProtectionAdapters = (): BotProtectionProviderAdapter[] =>
  Array.from(ADAPTERS_BY_PROVIDER.values())
